<div
  [ngClass]="classList"
  class="med-label"
>
  <label
    *ngIf="label"
    [attr.for]="name"
    [ngClass]="{ disabled }"
    class="med-label__name"
  >
    {{ label }}
    <span
      *ngIf="required"
      class="med-label__required"
    >
      *
    </span>
  </label>

  <div class="med-label__content">
    <ng-content></ng-content>
  </div>
</div>
